import React, { createContext, useContext, useState, useCallback } from 'react';

const AcumenCommandContext = createContext();

const defaultSlots = [
  {id: 'slot1', color: '#3b82f6', name: 'VIBE', mode: 'vibe', agents: [{id: 'acumen-10', label: 'Acumen-10', color: '#3b82f6'}]},
  {id: 'slot2', color: '#10b981', name: 'CONTEXT', mode: 'context', agents: []},
  {id: 'slot3', color: '#f59e0b', name: 'HELP', mode: 'help', agents: []},
  {id: 'slot4', color: '#ef4444', name: 'COMPLY', mode: 'comply', agents: [{id: 'acumen-10', label: 'Acumen-10', color: '#ef4444'}]},
  {id: 'slot5', color: '#8b5cf6', name: 'GENERATE', mode: 'generate', agents: [{id: 'acumen-10', label: 'Acumen-10', color: '#8b5cf6'}]}
];

export const AcumenCommandProvider = ({ children }) => {
  const [activeTool, setActiveTool] = useState(null);
  const [activeAgent, setActiveAgent] = useState(null);
  const [capturedContext, setCapturedContext] = useState([]);
  const [barPosition, setBarPosition] = useState({ docked: 'top', x: 0, y: 0 });
  const [slots, setSlots] = useState(defaultSlots);

  const activateTool = useCallback((mode, agent = null) => {
    setActiveTool(mode);
    setActiveAgent(agent);
  }, []);

  const deactivateTool = useCallback(() => {
    setActiveTool(null);
    setActiveAgent(null);
  }, []);

  const captureContext = useCallback((item) => {
    setCapturedContext(prev => [...prev, {
      ...item,
      timestamp: Date.now()
    }]);
  }, []);

  const clearCapturedContext = useCallback(() => {
    setCapturedContext([]);
  }, []);

  const updateSlots = useCallback((newSlots) => {
    setSlots(newSlots);
  }, []);

  const value = {
    activeTool,
    activeAgent,
    capturedContext,
    barPosition,
    slots,
    activateTool,
    deactivateTool,
    captureContext,
    clearCapturedContext,
    setBarPosition,
    updateSlots
  };

  return (
    <AcumenCommandContext.Provider value={value}>
      {children}
    </AcumenCommandContext.Provider>
  );
};

export const useAcumenCommand = () => {
  const context = useContext(AcumenCommandContext);
  if (!context) {
    throw new Error('useAcumenCommand must be used within an AcumenCommandProvider');
  }
  return context;
};
